import { cache } from '@cornerstonejs/core';
import { utilities } from '@cornerstonejs/metadata';
import dataSetCacheManager from './wadouri/dataSetCacheManager.js';
import wadorsMetaDataManager from './wadors/metaDataManager.js';
import wadouriRegister from './wadouri/register.js';
import wadorsRegister from './wadors/register.js';
function registerLoaders(options) {
    cache.purgeCache();
    dataSetCacheManager.purge();
    wadorsMetaDataManager.purge();
    utilities.clearCacheData();
    wadorsRegister(options);
    wadouriRegister(options);
}
export default registerLoaders;
